import { useMagicKeys, whenever } from '@vueuse/core'
import { useDialogMessage } from '@/features/touch-map/messages/useDialogMessage'

export function useDebugKeyDialogMessage() {
  const keys = useMagicKeys()
  const message = useDialogMessage('debug')

  whenever(keys.numpad1, () => message.OpenDialogCommand('location1-th'))
  whenever(keys.numpad2, () => message.OpenDialogCommand('location2-th'))
  whenever(keys.numpad3, () => message.OpenDialogCommand('location3-th'))
  whenever(keys.numpad4, () => message.OpenDialogCommand('location4-th'))
  whenever(keys.numpad5, () => message.OpenDialogCommand('location5-th'))
  whenever(keys.numpad6, () => message.OpenDialogCommand('location6-th'))
  whenever(keys.numpad7, () => message.OpenDialogCommand('location7-th'))
  whenever(keys.numpad8, () => message.OpenDialogCommand('abbot-th'))
  whenever(keys.numpad9, () => {
    for (let i = 1; i <= 7; i++) {
      message.OpenDialogCommand(`location${8-i}-th`)
    }
    message.OpenDialogCommand(`abbot-th`)
  })

  whenever(keys.numpad0, () => message.CloseDialogCommand('*'))
}
